import React from 'react'
import { ModalIndication } from 'components/lib/modals'
import type { Dispatch, PropsWithChildren } from 'react'
import { useState } from 'react'
import { post_event } from 'utils/analytics'
import { IndicationContentType } from 'api/data.types'
import useToast from 'utils/hooks/use-toast'

interface BookIndicationProps extends PropsWithChildren {
  title: string
  author: string
  imageUrlThumb: string
  image?: string
  id?: number
  slug: string
  contentType: IndicationContentType
  setIsOpen?: Dispatch<boolean>
  onClose: () => void
}

const BookIndication: React.FC<BookIndicationProps> = ({
  title,
  author,
  imageUrlThumb,
  image,
  id,
  slug,
  setIsOpen,
  onClose,
  children,
  contentType
}) => {
  const [indicationModal, setIndicationModal] = useState(false)
  const [indicationWithBookName, setIndicationWithBookName] = useState(null)
  const { toastMessage } = useToast()

  const indication = () => {
    post_event(`ClickIndicarModalMaisAcoes`, slug)
    openIndicationModalWithCurrentBook(true)
  }

  const openIndicationModalWithCurrentBook = value => {
    setIndicationModal(value)
    setIndicationWithBookName({
      name: title,
      author: author,
      imageUrlThumb: imageUrlThumb,
      slug: slug,
      image: image,
      id: id
    })
  }

  const showSuccessMessage = () => {
    toastMessage({
      message:
        contentType === IndicationContentType.VIDEO
          ? 'Vídeo indicado com sucesso!'
          : 'Livro indicado com sucesso!',
      type: 'success'
    })
  }

  const trigger = React.isValidElement<{
    onClick?: React.MouseEventHandler
  }>(children) ? (
    React.cloneElement(children, {
      onClick: event => {
        children.props.onClick?.(event)
        indication()
      }
    })
  ) : (
    <span onClick={indication}>{children}</span>
  )

  return (
    <>
      {indicationModal && (
        <ModalIndication
          contentType={contentType}
          modalVisibility={indicationModal}
          handleModalVisibility={openIndicationModalWithCurrentBook}
          handleSuccessMessage={showSuccessMessage}
          indicationWithBookName={indicationWithBookName}
          setIsOpen={setIsOpen}
          onClose={onClose}
        />
      )}
      {trigger}
    </>
  )
}

export default BookIndication
